module.exports = __webpack_public_path__ + "img/home.7d26b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home.png
// module id = P7rK
// module chunks = 83